import { SetAssignVisitRequestCancelledByExpert } from 'Application/Visits/Actions/action'
import { useTranslation } from 'react-i18next'
import { useDispatch } from 'react-redux'
import { useNavigate } from 'react-router-dom'

type Props = {
  visitRequestId: number
  isEnabled: boolean
}

const CancelRequestButton = ({ visitRequestId, isEnabled }: Props) => {
  const dispatch = useDispatch<any>()
  const navigate = useNavigate()
  const { t } = useTranslation()

  return (
    <button
      className="btn btn-text-error btn-lg flex gap-2 items-center justify-center w-full"
      disabled={!isEnabled}
      onClick={async () => {
        if (!isEnabled) return

        try {
          await dispatch(
            SetAssignVisitRequestCancelledByExpert({
              data: {
                visitRequestId,
              },
              navigate,
              t: t('EDIT_REQUEST'),
            }),
          ).unwrap()
        } catch (error) {}
      }}
    >
      {t('CANCEL_EXPERTS')}
    </button>
  )
}

export default CancelRequestButton
